const MONTHS = [
  "", "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export function formatRupiah(value) {
  const n = Math.round(Number(value) || 0);
  return "Rp " + n.toLocaleString("id-ID");
}

export function formatTanggal(value) {
  if (!value) return "-";
  const d = new Date(value.length <= 10 ? value + "T00:00:00" : value);
  if (isNaN(d)) return "-";
  return `${d.getDate()} ${MONTHS[d.getMonth() + 1]} ${d.getFullYear()}`;
}

export function formatTanggalWaktu(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d)) return "-";
  const opt = { timeZone: "Asia/Jakarta", hour: "2-digit", minute: "2-digit", hour12: false };
  const parts = new Intl.DateTimeFormat("id-ID", { timeZone: "Asia/Jakarta", day: "numeric", month: "long", year: "numeric" }).format(d);
  const time = new Intl.DateTimeFormat("id-ID", opt).format(d);
  return `${parts}, ${time} WIB`;
}

export function nowLocalInput() {
  const d = new Date();
  const off = d.getTimezoneOffset();
  const local = new Date(d.getTime() - off * 60000);
  return local.toISOString().slice(0, 16);
}

export const RENTAL_STATUS = {
  tersedia: { label: "Tersedia", bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" },
  dipesan: { label: "Dipesan (DP)", bg: "#fff7ed", text: "#c2410c", border: "#ffedd5" },
  menunggu_masuk: { label: "Menunggu Masuk", bg: "#f0f9ff", text: "#0369a1", border: "#bae6fd" },
  terisi: { label: "Terisi", bg: "#f1f5f9", text: "#334155", border: "#cbd5e1" },
};

export const CONDITION = {
  siap: { label: "Siap Digunakan", bg: "#f0fdf4", text: "#15803d", border: "#bbf7d0" },
  disiapkan: { label: "Sedang Disiapkan", bg: "#fefce8", text: "#a16207", border: "#fef08a" },
};

export const LEASE_STATUS = {
  awaiting_movein: { label: "Menunggu Masuk", bg: "#f0f9ff", text: "#0369a1", border: "#bae6fd" },
  active: { label: "Aktif", bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" },
  scheduled: { label: "Perpanjangan Terjadwal", bg: "#faf5ff", text: "#7e22ce", border: "#e9d5ff" },
  ended: { label: "Selesai", bg: "#f1f5f9", text: "#475569", border: "#cbd5e1" },
  early_exit: { label: "Keluar Lebih Awal", bg: "#fef2f2", text: "#b91c1c", border: "#fecaca" },
  cancelled: { label: "Dibatalkan", bg: "#f1f5f9", text: "#475569", border: "#cbd5e1" },
};

export const APPROVAL_STATUS = {
  pending: { label: "Menunggu", bg: "#fff7ed", text: "#c2410c", border: "#ffedd5" },
  approved: { label: "Disetujui", bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" },
  rejected: { label: "Ditolak", bg: "#fef2f2", text: "#b91c1c", border: "#fecaca" },
  cancelled: { label: "Dibatalkan", bg: "#f1f5f9", text: "#475569", border: "#cbd5e1" },
  conflict: { label: "Konflik — Ajukan Ulang", bg: "#faf5ff", text: "#7e22ce", border: "#e9d5ff" },
  applying: { label: "Diproses", bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
};

export const PAYMENT_TYPE = {
  dp: "DP Booking",
  settlement: "Pelunasan",
  extension_settlement: "Pelunasan Perpanjangan",
  direct_settlement: "Sewa Langsung (Tanpa DP)",
};

export const APPROVAL_TYPE = {
  room_price: "Perubahan Harga Kamar",
  payment_amount: "Koreksi Nominal Pembayaran",
  payment_date: "Koreksi Tanggal Pembayaran",
  payment_method: "Koreksi Metode Pembayaran",
  payment_cancel: "Pembatalan Pembayaran",
  extension_price: "Harga Khusus Perpanjangan",
};
